module.exports = __webpack_public_path__ + "img/index1.296968e7.jpg";